import React, { useMemo, useState } from 'react';
import {
  // Chart as ChartJS, // Removed ChartJS imports
  // CategoryScale,
  // LinearScale,
  // BarElement,
  // Title,
  // Tooltip,
  // Legend,
  // PointElement,
  // LineElement,
} from 'chart.js';
// import { Bar } from 'react-chartjs-2'; // Removed Bar import
import { Box, Typography, Paper, Grid } from '@mui/material'; // Added Grid
import AreaDetailModal from './AreaDetailModal'; // Import the new modal
import LinearProgress from '@mui/material/LinearProgress'; // For the mini-progress bar

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   PointElement,
//   LineElement,
// ); // Removed ChartJS registration

export default function BenchmarkByArea({ data }) {
  const [isAreaModalOpen, setIsAreaModalOpen] = useState(false);
  const [selectedAreaData, setSelectedAreaData] = useState(null);

  // Calculate average score for each area to display on the card
  const areaSummaries = useMemo(() => {
    if (!data || data.length === 0) return []; // Ensure data is not null/empty before processing
    return data.map(item => {
      const totalCount = Object.values(item.distribucion_puntaje).reduce((sum, count) => sum + count, 0);
      let weightedSum = 0;
      Object.entries(item.distribucion_puntaje).forEach(([score, count]) => {
        weightedSum += parseInt(score) * count;
      });
      const averageScore = totalCount > 0 ? weightedSum / totalCount : 0;
      return { ...item, averageScore };
    }).sort((a, b) => a.area.localeCompare(b.area)); // Sort areas alphabetically
  }, [data]);

  const handleAreaClick = (areaName, distribution) => {
    setSelectedAreaData({ areaName, distribution });
    setIsAreaModalOpen(true);
  };

  const handleCloseAreaModal = () => {
    setIsAreaModalOpen(false);
    setSelectedAreaData(null);
  };

  // Removed chartData and options useMemos as they are no longer needed

  if (!data || data.length === 0) {
    return (
      <Paper elevation={3} sx={{ p: 3, borderRadius: '12px', textAlign: 'center' }}>
        <Typography variant="subtitle1">No hay datos de benchmark por área disponibles para el período seleccionado.</Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: '12px' }}>
      <Grid container spacing={2}> {/* Grid for area cards */}
        {areaSummaries.map((areaData) => (
          <Grid item xs={12} sm={6} md={4} key={areaData.area}> 
            <Paper
              elevation={3} 
              sx={{
                p: 2,
                borderRadius: '12px',
                cursor: 'pointer',
                '&:hover': { boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)' },
                transition: 'box-shadow 0.3s ease-in-out',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              onClick={() => handleAreaClick(areaData.area, areaData.distribucion_puntaje)}
            >
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>{areaData.area}</Typography>
                <Typography variant="body2" color="text.secondary">Puntaje Promedio Calibrado:</Typography>
                <Typography variant="h5" color="primary" sx={{ fontWeight: 'bold' }}>{areaData.averageScore.toFixed(2)}</Typography>
              </Box>
              <Box mt={2}>
                <LinearProgress 
                  variant="determinate" 
                  value={(areaData.averageScore / 5) * 100} 
                  sx={{ height: 8, borderRadius: 4, backgroundColor: '#e0e0e0' }}
                />
                <Typography variant="caption" color="text.secondary" mt={0.5} textAlign="right">
                  {((areaData.averageScore / 5) * 100).toFixed(0)}% del máximo
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {selectedAreaData && (
        <AreaDetailModal
          open={isAreaModalOpen}
          handleClose={handleCloseAreaModal}
          areaName={selectedAreaData.areaName}
          distribution={selectedAreaData.distribution}
        />
      )}
    </Paper>
  );
}